import { FiservConfiguration, ParPayConfiguration, WorldpayConfiguration } from '@ocx/graphql';

import { PAYMENT_PROVIDER_TYPE, PaymentProviderConfiguration } from '../app-config.types';

type PaymentProviderConfigurationFragment =
  | ({ __typename: 'FiservConfiguration' } & FiservConfiguration)
  | ({ __typename: 'ParPayConfiguration' } & ParPayConfiguration)
  | ({ __typename: 'WorldpayConfiguration' } & WorldpayConfiguration);

export const mapPaymentProviderConfigurationFragment = (
  paymentProviderFragment: PaymentProviderConfigurationFragment,
): PaymentProviderConfiguration => {
  if (paymentProviderFragment.__typename === 'WorldpayConfiguration') {
    return {
      type: PAYMENT_PROVIDER_TYPE.WORLDPAY,
      eProtectPayPageId: paymentProviderFragment.eProtectPayPageId,
      eProtectGooglePayPageId: paymentProviderFragment.eProtectGooglePayPageId,
      eProtectWebSdkApiUrl: paymentProviderFragment.eProtectWebSdkApiUrl,
      eProtectWebSdkUrl: paymentProviderFragment.eProtectWebSdkUrl,
    };
  }

  if (paymentProviderFragment.__typename === 'FiservConfiguration') {
    return {
      type: PAYMENT_PROVIDER_TYPE.FISERV,
    };
  }

  if (paymentProviderFragment.__typename === 'ParPayConfiguration') {
    return {
      type: PAYMENT_PROVIDER_TYPE.PAR_PAY,
    };
  }

  return null;
};
